export default `float de(vec3 p){
    float radius = .3;    
    int waves = 7;        
    float waveSize = 0.4; 

    
    float d = length(p) - radius*2.2;
    if(d > 0.0) return 0.2;

    
    d = waveSize * (radius*radius-(p.y*p.y));
    radius += d * cos(atan(p.x,p.z) * float(waves));
    return 0.5*(length(p) - radius);
  }`